// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import thermometerWarmIcon from "@/assets/icons/thermometer-warm.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ThermometerWarmIconProps = Omit<IconProps, "name">;

export function ThermometerWarmIcon(props: ThermometerWarmIconProps): React.ReactNode {
  return <Icon name={thermometerWarmIcon} {...props} />;
}
